module.exports = __webpack_public_path__ + "img/tutorial_results-collections.dcd6f9a7.png";